import type { MessageAuthor, ShownMessage } from "@beacon/core/chat"

/*
 * Who said a message, as every surface says it: a Member by name, or Beacon, answering whoever
 * asked it ("Beacon (asked by Ada)"), never as that Member's own words.
 */

/** Who said a message, in words: a Member's name, or Beacon and whoever asked it. */
export function authorWords(author: MessageAuthor): string {
  return author.kind === "member" ? author.name : `Beacon (asked by ${author.askedBy.name})`
}

/** Whose a message is, said as its owner: "your" for the Member's own, else a name's. */
export function whose(author: MessageAuthor, me: string): string {
  if (author.kind === "beacon") return "Beacon's"
  return author.id === me ? "your" : `${author.name}'s`
}

/** Whether the Member `memberId` said the message: Beacon's reply is no Member's. */
export const saidBy = (message: Pick<ShownMessage, "author">, memberId: string) =>
  message.author?.kind === "member" && message.author.id === memberId

/**
 * Whether the Member `memberId` deletes the message as their own: its author, or whoever asked for
 * Beacon's reply.
 */
export const ownedBy = (message: Pick<ShownMessage, "author">, memberId: string) =>
  message.author !== null &&
  (message.author.kind === "member"
    ? message.author.id === memberId
    : message.author.askedBy.id === memberId)

/** Whether two authors are the one Member (Beacon's replies stand apart, each its own). */
export const sameMember = (a: MessageAuthor | null, b: MessageAuthor | null) =>
  a?.kind === "member" && b?.kind === "member" && a.id === b.id

/** Who an author is, as a key among others: a Member's id, or Beacon. */
export const authorKey = (author: MessageAuthor) =>
  author.kind === "member" ? author.id : "beacon"
